var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgResiliency(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1410 886.56"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "resiliency_svg__a",
    x1: 1141.06,
    y1: 130.11,
    x2: 843.18,
    y2: 226.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b1cfde"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "resiliency_svg__b",
    x1: 1110.42,
    y1: 140.07,
    x2: 873.83,
    y2: 216.94,
    xlinkHref: "#resiliency_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "resiliency_svg__c",
    x1: 658.79,
    y1: 228.72,
    x2: 306.22,
    y2: 839.38,
    xlinkHref: "#resiliency_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "resiliency_svg__d",
    x1: 629.91,
    y1: 275.72,
    x2: 335.11,
    y2: 786.32,
    xlinkHref: "#resiliency_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "resiliency_svg__e",
    x1: 565.41,
    y1: 387.44,
    x2: 399.61,
    y2: 674.6,
    xlinkHref: "#resiliency_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "resiliency_svg__f",
    x1: 644.78,
    y1: 168.33,
    x2: 324.71,
    y2: 272.33,
    xlinkHref: "#resiliency_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "resiliency_svg__g",
    x1: 328.26,
    y1: 607.58,
    x2: 8.19,
    y2: 711.58,
    xlinkHref: "#resiliency_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "resiliency_svg__h",
    x1: 960.07,
    y1: 601.14,
    x2: 640,
    y2: 705.13,
    xlinkHref: "#resiliency_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "resiliency_svg__m",
    x1: 1402.37,
    y1: 479.97,
    x2: 1104.5,
    y2: 576.75,
    xlinkHref: "#resiliency_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "resiliency_svg__n",
    x1: 1371.73,
    y1: 489.92,
    x2: 1135.14,
    y2: 566.8,
    xlinkHref: "#resiliency_svg__a"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "resiliency_svg__i"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 485.29,
    cy: 221.53,
    rx: 100.26,
    ry: 100.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "resiliency_svg__j"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 485.64,
    cy: 221.17,
    rx: 100.26,
    ry: 100.75,
    fill: "none",
    stroke: "#0e1932",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.265
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "resiliency_svg__k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M871.53 616.41h14.74v-10.78a6.41 6.41 0 00-6.49-6.48H721.39a6.41 6.41 0 00-6.49 6.48v106.59a6.41 6.41 0 006.49 6.48h140v-92.15a10 10 0 0110.14-10.14z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "resiliency_svg__l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.86 586.87h176.68c5.16-.54 8.28 2.66 8.28 7.73v113.11H79.58V594.6c0-5.08 3.13-8.28 8.28-7.73z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "resiliency_svg__o"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1255.4 486.29c-35.36 0-64.26-8.62-66.36-19.51l-.04 121.6c3.41 10.48 31.75 18.85 66.26 18.85s63-8.37 66.41-18.85l.1-121.58c-2.14 10.88-31.03 19.49-66.37 19.49z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "resiliency_svg__p"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M909.78 108.73h167.62a9.73 9.73 0 019.86 9.85v19.69a9.73 9.73 0 01-9.86 9.85H909.78a9.73 9.73 0 01-9.86-9.85v-19.69a9.73 9.73 0 019.86-9.85z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "resiliency_svg__q"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M909.78 162.11h167.62a9.73 9.73 0 019.86 9.85v19.69a9.73 9.73 0 01-9.86 9.85H909.78a9.73 9.73 0 01-9.86-9.85V172a9.73 9.73 0 019.86-9.89z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "resiliency_svg__r"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M909.78 215h167.62a9.73 9.73 0 019.86 9.85v19.65a9.73 9.73 0 01-9.86 9.85H909.78a9.73 9.73 0 01-9.86-9.85v-19.7a9.73 9.73 0 019.86-9.8z",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 992.12,
    cy: 178.51,
    r: 156.56,
    opacity: 0.4,
    fill: "url(#resiliency_svg__a)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 992.12,
    cy: 178.51,
    r: 124.35,
    opacity: 0.4,
    fill: "url(#resiliency_svg__b)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 482.51,
    cy: 534.05,
    r: 352.51,
    opacity: 0.4,
    fill: "url(#resiliency_svg__c)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 482.51,
    cy: 531.02,
    r: 294.75,
    opacity: 0.4,
    fill: "url(#resiliency_svg__d)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 482.51,
    cy: 531.02,
    r: 165.76,
    opacity: 0.4,
    fill: "url(#resiliency_svg__e)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 484.75,
    cy: 220.33,
    r: 168.22,
    opacity: 0.4,
    fill: "url(#resiliency_svg__f)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168.22,
    cy: 659.58,
    r: 168.22,
    opacity: 0.4,
    fill: "url(#resiliency_svg__g)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 800.03,
    cy: 653.13,
    r: 168.22,
    opacity: 0.4,
    fill: "url(#resiliency_svg__h)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 483.26,
    cy: 533.14,
    r: 352.51,
    fill: "none",
    stroke: "#a8c0dd",
    strokeMiterlimit: 10,
    strokeWidth: 0.717
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 483.26,
    cy: 533.14,
    r: 294.75,
    fill: "none",
    stroke: "#a8c0dd",
    strokeMiterlimit: 10,
    strokeWidth: 0.717
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 483.26,
    cy: 533.14,
    r: 165.76,
    fill: "none",
    stroke: "#a8c0dd",
    strokeMiterlimit: 10,
    strokeWidth: 0.717
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 485.65,
    cy: 222.42,
    rx: 100.42,
    ry: 100.9,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.33 585.67H264c5.16-.54 8.28 2.66 8.28 7.73v113.11H79V593.4c0-5.08 3.17-8.27 8.33-7.73zM62.48 721.43h226.37v5.52c0 2.53-1.22 4.26-3.71 5.78a20.15 20.15 0 01-10.09 2.5H76.29a20.15 20.15 0 01-10.09-2.5c-2.49-1.52-3.71-3.25-3.71-5.78zm880.1-104.91h-70.12a10 10 0 00-10.15 10.14v126.71a10 10 0 0010.15 10.14h70.12a10.43 10.43 0 0010.15-10.14V626.66a10 10 0 00-10.15-10.14zM722 599.25h88v-1a9.82 9.82 0 00-10-9.94H630.78a9.82 9.82 0 00-10 9.94v19.89a9.82 9.82 0 0010 9.94h84.77v-22.34a6.41 6.41 0 016.45-6.49zm-91.22 39.46a9.82 9.82 0 00-10 9.94v19.89a9.82 9.82 0 0010 9.94h84.77v-39.77z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.17 616.52h14.74v-10.78a6.41 6.41 0 00-6.49-6.48H722a6.41 6.41 0 00-6.49 6.48v106.59a6.41 6.41 0 006.49 6.48h140.7v-92.15c.04-5.66 3.76-10.14 9.47-10.14zm-84.28 111.81v17.09h26.68v-26.58h-26.68v9.49z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M787.89 729.5H630.78a9.82 9.82 0 01-10-9.94v-19.89a9.82 9.82 0 0110-9.94h84.77v23.78h73.37z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#resiliency_svg__i)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 490.7,
    cy: 227.14,
    r: 100.28,
    fill: "#6bc6c4",
    opacity: 0.47
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#resiliency_svg__j)",
    fill: "none",
    stroke: "#0e1932",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.265
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 375.2,
    cy: 204.63,
    rx: 139.77,
    ry: 140.44
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 451.82,
    cy: 317.71,
    rx: 139.77,
    ry: 140.44
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 541.61,
    cy: 331.54,
    rx: 139.77,
    ry: 140.44
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 524.85,
    cy: 142.08,
    rx: 139.77,
    ry: 140.44
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 485.64,
    cy: 221.17,
    rx: 100.26,
    ry: 100.75
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 485.64,
    cy: 221.17,
    rx: 100.26,
    ry: 100.75,
    fill: "none",
    stroke: "#0e1932",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.265
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 514.97,
    cy: 192.9,
    rx: 8.68,
    ry: 8.72,
    fill: "#253a60",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 431.17,
    cy: 245.83,
    rx: 8.68,
    ry: 8.72,
    fill: "#253a60",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 492.82,
    cy: 278.91,
    rx: 8.68,
    ry: 8.72,
    fill: "#253a60",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0e1932",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.265,
    d: "M556.43 128.12l21.55-21.64m-2.45 19.59l3.58-20.43-20.15 3.66m-2.53 204.92l21.55 21.64m-2.45-19.59l3.58 20.43-20.15-3.66M414.85 128.12l-21.56-21.64m2.46 19.59l-3.58-20.43 20.15 3.66m2.53 204.92l-21.56 21.64m2.46-19.59l-3.58 20.43 20.15-3.66"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#resiliency_svg__k)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M877.4 622.28h14.74V611.5a6.41 6.41 0 00-6.49-6.48H727.26a6.41 6.41 0 00-6.49 6.48v106.59a6.41 6.41 0 006.49 6.48h140v-92.15a10 10 0 0110.14-10.14z",
    fill: "#6bc6c4",
    opacity: 0.47
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#resiliency_svg__l)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96 591.21h176.68c5.16-.54 8.28 2.66 8.28 7.73V712H87.72V598.94c0-5.08 3.13-8.28 8.28-7.73z",
    fill: "#6bc6c4",
    opacity: 0.47
  })), /*#__PURE__*/React.createElement("path", {
    d: "M87.15 586.87h176.67c5.16-.54 8.28 2.66 8.28 7.73v113.11H78.87V594.6c0-5.08 3.13-8.28 8.28-7.73zM62.3 722.62h226.37v5.52c0 2.53-1.22 4.26-3.71 5.78a20.15 20.15 0 01-10.09 2.5H76.11a20.15 20.15 0 01-10.11-2.5c-2.49-1.52-3.71-3.25-3.71-5.78zm41.15-74.72h91.13m-91.13-32.52h91.13m-91.13 64.94h91.13",
    fill: "none",
    stroke: "#0e1932",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246 606.4h-18.13a8.62 8.62 0 00-8.57 8.6 8.62 8.62 0 008.61 8.55h18.13a8.62 8.62 0 008.57-8.59 8.62 8.62 0 00-8.61-8.56zm0 65.05h-18.13a8.62 8.62 0 00-8.57 8.59 8.62 8.62 0 008.61 8.55h18.13a8.62 8.62 0 008.57-8.59 8.62 8.62 0 00-8.61-8.55zm0-32.52h-18.13a8.62 8.62 0 00-8.57 8.59 8.62 8.62 0 008.61 8.55h18.13a8.62 8.62 0 008.57-8.59 8.62 8.62 0 00-8.61-8.55z",
    fill: "none",
    stroke: "#0e1932",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.265
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 228.51,
    cy: 680.02,
    rx: 4.46,
    ry: 4.45,
    transform: "rotate(-.11 228.528 682.56)",
    fill: "#253a60",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 228.51,
    cy: 647.49,
    rx: 4.46,
    ry: 4.45,
    transform: "rotate(-.11 228.563 646.1)",
    fill: "#253a60",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 228.51,
    cy: 614.97,
    rx: 4.46,
    ry: 4.45,
    transform: "rotate(-.11 228.593 614.847)",
    fill: "#253a60",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M941.94 616.41h-70.13a10 10 0 00-10.15 10.14v126.7a10 10 0 0010.15 10.14h70.12a10.43 10.43 0 0010.15-10.14v-126.7a10 10 0 00-10.14-10.14z",
    fill: "none",
    stroke: "#0e1932",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M916.55 629.31H897.2a3.48 3.48 0 110-7h19.36a3.52 3.52 0 013.49 3.48c-.32 2.21-1.59 3.52-3.5 3.52z",
    fill: "#253a60",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M907 748.51a3.5 3.5 0 01-3.26-3.26 4.26 4.26 0 01.82-2.24 3.2 3.2 0 014.48 0 3 3 0 010 4.48 2.51 2.51 0 01-2.04 1.02z",
    fill: "#253a60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.39 599.14h88v-1a9.82 9.82 0 00-10-9.94H630.13a9.82 9.82 0 00-10 9.94v19.89a9.82 9.82 0 0010 9.94h84.77v-22.34a6.41 6.41 0 016.49-6.49zm-91.26 39.46a9.82 9.82 0 00-10 9.94v19.89a9.82 9.82 0 0010 9.94h84.77V638.6zm84.77 74.79v-23.78h-84.77a9.82 9.82 0 00-10 9.94v19.89a9.82 9.82 0 0010 9.94h157.12",
    fill: "none",
    stroke: "#0e1932",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.265
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 645.64,
    cy: 607.64,
    fill: "#253a60",
    opacity: 0.7,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 672.45,
    cy: 607.64,
    fill: "#253a60",
    opacity: 0.7,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 699.27,
    cy: 607.64,
    fill: "#253a60",
    opacity: 0.7,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 645.64,
    cy: 658.46,
    fill: "#253a60",
    opacity: 0.7,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 672.45,
    cy: 658.46,
    fill: "#253a60",
    opacity: 0.7,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 699.27,
    cy: 658.46,
    fill: "#253a60",
    opacity: 0.7,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 645.64,
    cy: 709.38,
    fill: "#253a60",
    opacity: 0.7,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 672.45,
    cy: 709.38,
    fill: "#253a60",
    opacity: 0.7,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 699.27,
    cy: 709.38,
    fill: "#253a60",
    opacity: 0.7,
    r: 6.7
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0e1932",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.265,
    d: "M836.44 746.37h-71.71m106.8-129.96h14.74v-10.78a6.41 6.41 0 00-6.49-6.48H721.39a6.41 6.41 0 00-6.49 6.48v106.59a6.41 6.41 0 006.49 6.48h140v-92.15a10 10 0 0110.14-10.14zm-84.28 111.8v17.09h26.67v-26.58h-26.67v9.49z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M799.23 708a2.44 2.44 0 00-.65 1.72 2.14 2.14 0 00.75 1.72 2.44 2.44 0 003.45-3.45 2.77 2.77 0 00-3.55.01z",
    fill: "#253a60",
    stroke: "#84898d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.936,
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0e1932",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.265,
    d: "M715.23 701.07h145.93"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 160.24,
    cy: 548.02,
    r: 8.96,
    fill: "none",
    stroke: "#0e1932",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.265
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 624.71,
    cy: 244.22,
    r: 8.96,
    transform: "rotate(-61.56 624.708 244.222)",
    fill: "#dbe8ee",
    stroke: "#0e1932",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.265
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 753.13,
    cy: 306.49,
    r: 8.96,
    fill: "#253a60",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 583.66,
    cy: 810,
    r: 7.17,
    fill: "#253a60",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.94,
    cy: 358.51,
    r: 6.81,
    fill: "#253a60",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334.21,
    cy: 605.94,
    r: 6.09,
    fill: "#253a60",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1253.43,
    cy: 528.36,
    r: 156.56,
    opacity: 0.4,
    fill: "url(#resiliency_svg__m)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1253.43,
    cy: 528.36,
    r: 124.35,
    opacity: 0.4,
    fill: "url(#resiliency_svg__n)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#resiliency_svg__o)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1261.14 489.43c-35.36 0-64.26-8.62-66.36-19.51l-.05 121.59c3.41 10.48 31.75 18.85 66.26 18.85s63-8.37 66.41-18.85l.1-121.58c-2.12 10.89-31.01 19.5-66.36 19.5z",
    fill: "#6bc6c4",
    opacity: 0.47
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1188.46 506.95c3.41 10.48 31.8 18.65 66.31 18.65s62.9-8.18 66.31-18.65",
    fill: "none",
    stroke: "#0e1932",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.265
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1254.93,
    cy: 464.51,
    rx: 66.5,
    ry: 20.78,
    fill: "none",
    stroke: "#0e1932",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1188.46 547.26c3.41 10.48 31.8 18.65 66.31 18.65s62.9-8.18 66.31-18.65",
    fill: "none",
    stroke: "#0e1932",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1188.57 462.62l-.05 124.75c3.41 10.48 31.75 18.85 66.26 18.85s63-8.37 66.41-18.85l.1-124.75M972.25 765.77h65.94v26.29h-65.94z",
    fill: "none",
    stroke: "#0e1932",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.265
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#253a60",
    opacity: 0.7,
    d: "M979.42 771.77h51.59v14.29h-51.59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0e1932",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.265,
    d: "M978.74 765.79v-9.27m13.24 9.27v-9.27m13.23 9.27v-9.27m13.24 9.27v-9.27m13.24 9.27v-9.27m-52.95 44.79v-9.28m13.24 9.28v-9.28m13.23 9.28v-9.28m13.24 9.28v-9.28m13.24 9.28v-9.28m-26.29-70.24l.06 22.03m-8.75-11.25l8.61 12.25 8.39-12.13M990.13 711l30.21-.06a14.38 14.38 0 0014.29-14.34 14.38 14.38 0 00-14.34-14.29l-30.21.06a14.38 14.38 0 00-14.29 14.34A14.38 14.38 0 00990.13 711z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1019.29,
    cy: 696.66,
    r: 7.43,
    transform: "rotate(-.11 1020.241 693.738)",
    fill: "#253a60",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1020.29 643.94l-30.21.06a14.38 14.38 0 00-14.29 14.34 14.38 14.38 0 0014.34 14.29l30.21-.06a14.38 14.38 0 0014.29-14.34 14.38 14.38 0 00-14.34-14.29z",
    fill: "none",
    stroke: "#0e1932",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.265
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 991.14,
    cy: 658.24,
    r: 7.43,
    transform: "rotate(-.11 989.024 657.247)",
    fill: "#253a60",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 996.71,
    cy: 287.63,
    r: 8.96,
    transform: "rotate(-61.56 996.702 287.638)",
    fill: "#e9f2f6",
    stroke: "#0e1932",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.265
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1073.64,
    cy: 732.8,
    rx: 33.98,
    ry: 34.01,
    fill: "#fff",
    stroke: "#0e1932",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.265
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0e1932",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.265,
    d: "M1064.23 726.82l-6.82 5.78-2.88-8.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1062.73 745.68a16.59 16.59 0 0011.93 5.09 17.38 17.38 0 10-16.59-20.56",
    fill: "none",
    stroke: "#0e1932",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.265
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 920.04,
    cy: 573.28,
    r: 8.96,
    transform: "rotate(-61.56 920.034 573.274)",
    fill: "none",
    stroke: "#0e1932",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.265
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    opacity: 0.2,
    d: "M166.52 530.36l-4.62-7.11-5 6.85-.26-.19 5.27-7.22 4.88 7.49-.27.18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinejoin: "round",
    strokeWidth: 0.063,
    opacity: 0.25,
    d: "M167.71 508.42l-4.5-7.92-5.8 7.02-.27-.22 6.12-7.41 4.75 8.36-.3.17z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinejoin: "round",
    strokeWidth: 0.125,
    opacity: 0.3,
    d: "M170.38 486.66l-4.27-8.75-6.67 7.1-.27-.25 7.03-7.5 4.51 9.24-.33.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinejoin: "round",
    strokeWidth: 0.188,
    opacity: 0.35,
    d: "M174.53 465.15l-3.94-9.59-7.57 7.1-.27-.29 7.98-7.49 4.16 10.12-.36.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinejoin: "round",
    strokeWidth: 0.25,
    opacity: 0.4,
    d: "M180.16 443.98l-3.51-10.43-8.5 6.99-.26-.33 8.97-7.37 3.7 11.01-.4.13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinejoin: "round",
    strokeWidth: 0.313,
    opacity: 0.45,
    d: "M187.27 423.21l-2.96-11.25-9.47 6.77-.25-.36 9.99-7.15 3.12 11.88-.43.11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinejoin: "round",
    strokeWidth: 0.375,
    opacity: 0.5,
    d: "M195.86 402.94l-2.3-12.06-10.45 6.44-.25-.4 11.03-6.79 2.42 12.72-.45.09z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinejoin: "round",
    strokeWidth: 0.438,
    opacity: 0.55,
    d: "M205.92 383.22l-1.52-12.82-11.44 5.99-.23-.44 12.07-6.31 1.6 13.52-.48.06z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinejoin: "round",
    strokeWidth: 0.5,
    opacity: 0.6,
    d: "M217.44 364.15l-.63-13.52-12.41 5.4-.21-.47 13.1-5.7.67 14.27-.52.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinejoin: "round",
    strokeWidth: 0.563,
    opacity: 0.65,
    d: "M230.26 345.78l.37-14.17-13.38 4.7-.17-.51 14.11-4.95-.39 14.95-.54-.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinejoin: "round",
    strokeWidth: 0.625,
    opacity: 0.7,
    d: "M244.16 328.2l1.47-14.74-14.3 3.87-.14-.54 15.08-4.08-1.55 15.54-.56-.05z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinejoin: "round",
    strokeWidth: 0.688,
    opacity: 0.75,
    d: "M259.48 311.48l2.67-15.21-15.17 2.92-.11-.57 16-3.09-2.81 16.05-.58-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinejoin: "round",
    strokeWidth: 0.75,
    opacity: 0.8,
    d: "M276.24 295.71l3.94-15.58-15.97 1.86-.07-.61 16.85-1.96-4.16 16.44-.59-.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinejoin: "round",
    strokeWidth: 0.813,
    opacity: 0.85,
    d: "M294.45 280.97l5.29-15.85-16.7.7-.03-.63 17.62-.75-5.57 16.73-.61-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinejoin: "round",
    strokeWidth: 0.875,
    opacity: 0.9,
    d: "M314.14 267.62l6.68-16.01-17.34-.53.02-.66 18.29.56-7.04 16.9-.61-.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinejoin: "round",
    strokeWidth: 0.938,
    opacity: 0.95,
    d: "M335.33 255.88l8.1-16.06-17.88-1.85.07-.68 18.87 1.96-8.55 16.94-.61-.31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinejoin: "round",
    d: "M358.03 245.44l9.54-15.99-18.34-3.22.13-.7 19.34 3.41-10.06 16.86-.61-.36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    opacity: 0.2,
    d: "M637.41 256.58l8.43-.9-3.84-7.56.29-.14 4.05 7.97-8.89.95-.04-.32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinejoin: "round",
    strokeWidth: 0.063,
    opacity: 0.25,
    d: "M655.15 266.96l9.11-.28-3.5-8.41.32-.13 3.69 8.87-9.61.29-.01-.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinejoin: "round",
    strokeWidth: 0.125,
    opacity: 0.3,
    d: "M672.29 278.68l9.73.42-3.07-9.24.35-.12 3.25 9.75-10.27-.44.01-.37z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinejoin: "round",
    strokeWidth: 0.188,
    opacity: 0.35,
    d: "M688.75 291.7l10.3 1.18-2.57-10.05.39-.1 2.71 10.61-10.88-1.24.05-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinejoin: "round",
    strokeWidth: 0.25,
    opacity: 0.4,
    d: "M704.42 306.09l10.83 2-1.99-10.83.41-.07 2.1 11.42-11.42-2.11.07-.41z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinejoin: "round",
    strokeWidth: 0.313,
    opacity: 0.45,
    d: "M719.24 321.76l11.28 2.88-1.32-11.56.44-.05 1.39 12.2-11.9-3.04.11-.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinejoin: "round",
    strokeWidth: 0.375,
    opacity: 0.5,
    d: "M733.12 338.64l11.67 3.82-.59-12.26.47-.02.61 12.93-12.3-4.03.14-.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinejoin: "round",
    strokeWidth: 0.438,
    opacity: 0.55,
    d: "M745.85 356.64l11.98 4.81.23-12.9.49.01-.24 13.61-12.64-5.07.18-.46z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinejoin: "round",
    strokeWidth: 0.5,
    opacity: 0.6,
    d: "M757.14 375.73l12.21 5.85 1.13-13.49.51.04-1.19 14.24-12.88-6.17.22-.47z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinejoin: "round",
    strokeWidth: 0.563,
    opacity: 0.65,
    d: "M767.17 395.71l12.36 6.95 2.09-14.02.53.08-2.21 14.79-13.03-7.33.26-.47z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinejoin: "round",
    strokeWidth: 0.625,
    opacity: 0.7,
    d: "M775.9 416.6l12.41 8.08 3.14-14.47.55.12-3.32 15.27-13.08-8.53.3-.47z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinejoin: "round",
    strokeWidth: 0.688,
    opacity: 0.75,
    d: "M783.24 438.28l12.35 9.27 4.27-14.85.56.17-4.5 15.66-13.03-9.78.35-.47z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinejoin: "round",
    strokeWidth: 0.75,
    opacity: 0.8,
    d: "M789.1 460.67l12.19 10.49 5.46-15.12.58.21-5.77 15.95-12.85-11.06.39-.47z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinejoin: "round",
    strokeWidth: 0.813,
    opacity: 0.85,
    d: "M793.41 483.7l11.9 11.74 6.73-15.3.58.26-7.1 16.14-12.55-12.38.44-.46z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinejoin: "round",
    strokeWidth: 0.875,
    opacity: 0.9,
    d: "M796.09 507.29l11.48 13 8.06-15.35.59.3-8.51 16.21-12.11-13.72.49-.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinejoin: "round",
    strokeWidth: 0.938,
    opacity: 0.95,
    d: "M797.05 531.37l10.94 14.27 9.44-15.3.59.36-9.97 16.14-11.54-15.06.54-.41z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinejoin: "round",
    d: "M796.23 556.07l10.25 15.54 10.87-15.11.58.42-11.48 15.94-10.81-16.4.59-.39z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    opacity: 0.2,
    d: "M642.28 245l6.04-5.94-7.7-3.53.13-.29 8.13 3.72-6.38 6.27-.22-.23z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    opacity: 0.28,
    d: "M664.69 241.08l6.71-6.71-8.66-3.88.14-.33 9.14 4.09-7.07 7.09-.26-.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinejoin: "round",
    strokeWidth: 0.2,
    opacity: 0.36,
    d: "M687.11 237.16l7.36-7.49-9.62-4.21.16-.37 10.15 4.45-7.77 7.9-.28-.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinejoin: "round",
    strokeWidth: 0.3,
    opacity: 0.44,
    d: "M709.52 233.24l8.03-8.26-10.58-4.56.18-.4 11.15 4.81-8.46 8.71-.32-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinejoin: "round",
    strokeWidth: 0.4,
    opacity: 0.52,
    d: "M731.94 229.31l8.68-9.03-11.53-4.9.19-.43 12.17 5.16-9.17 9.54-.34-.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinejoin: "round",
    strokeWidth: 0.5,
    opacity: 0.6,
    d: "M754.36 225.39l9.34-9.8-12.49-5.24.2-.48 13.18 5.53-9.86 10.35-.37-.36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinejoin: "round",
    strokeWidth: 0.6,
    opacity: 0.68,
    d: "M776.77 221.47l10-10.58-13.44-5.58.21-.51 14.19 5.89-10.55 11.16-.41-.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinejoin: "round",
    strokeWidth: 0.7,
    opacity: 0.76,
    d: "M799.19 217.55l10.66-11.35-14.4-5.92.22-.55 15.2 6.25-11.25 11.97-.43-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinejoin: "round",
    strokeWidth: 0.8,
    opacity: 0.84,
    d: "M821.61 213.63l11.31-12.13-15.35-6.26.24-.58 16.2 6.61-11.94 12.79-.46-.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinejoin: "round",
    strokeWidth: 0.9,
    opacity: 0.92,
    d: "M844.02 209.7L856 196.81l-16.31-6.6.25-.63 17.21 6.97-12.64 13.61-.49-.46z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinejoin: "round",
    d: "M866.44 205.78l12.64-13.66-17.27-6.95.26-.66 18.22 7.33-13.33 14.42-.52-.48z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    opacity: 0.2,
    d: "M987.95 298.39l1.01 8.42 7.51-3.94.15.29-7.92 4.15-1.07-8.88.32-.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinejoin: "round",
    strokeWidth: 0.077,
    opacity: 0.262,
    d: "M977.48 318.21l1.16 9.19 8.17-4.36.16.31-8.61 4.6-1.23-9.69.35-.05z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinejoin: "round",
    strokeWidth: 0.154,
    opacity: 0.323,
    d: "M967 338.04l1.33 9.94 8.82-4.78.18.34-9.31 5.04-1.4-10.49.38-.05z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinejoin: "round",
    strokeWidth: 0.231,
    opacity: 0.385,
    d: "M956.52 357.86l1.49 10.71 9.48-5.2.2.36-10 5.49-1.58-11.3.41-.06z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinejoin: "round",
    strokeWidth: 0.308,
    opacity: 0.446,
    d: "M946.04 377.68l1.65 11.48 10.14-5.63.21.39-10.69 5.93-1.74-12.1.43-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinejoin: "round",
    strokeWidth: 0.385,
    opacity: 0.508,
    d: "M935.57 397.5l1.81 12.24 10.79-6.04.23.41-11.39 6.38-1.91-12.92.47-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinejoin: "round",
    strokeWidth: 0.462,
    opacity: 0.569,
    d: "M925.09 417.33l1.97 13 11.45-6.47.25.44-12.08 6.82-2.08-13.72.49-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinejoin: "round",
    strokeWidth: 0.538,
    opacity: 0.631,
    d: "M914.62 437.15l2.13 13.77 12.1-6.89.27.46-12.78 7.27-2.25-14.53.53-.08z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinejoin: "round",
    strokeWidth: 0.615,
    opacity: 0.692,
    d: "M904.14 456.97l2.29 14.53 12.77-7.31.27.49-13.47 7.71-2.41-15.33.55-.09z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinejoin: "round",
    strokeWidth: 0.692,
    opacity: 0.754,
    d: "M893.66 476.8l2.45 15.29 13.43-7.73.29.51-14.16 8.16-2.59-16.14.58-.09z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinejoin: "round",
    strokeWidth: 0.769,
    opacity: 0.815,
    d: "M883.19 496.62l2.61 16.06 14.08-8.16.31.54-14.86 8.6-2.75-16.94.61-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinejoin: "round",
    strokeWidth: 0.846,
    opacity: 0.877,
    d: "M872.71 516.44l2.77 16.83 14.74-8.58.32.56-15.55 9.05-2.92-17.76.64-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinejoin: "round",
    strokeWidth: 0.923,
    opacity: 0.938,
    d: "M862.23 536.26l2.93 17.59 15.4-9 .34.59-16.24 9.49-3.09-18.56.66-.11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinejoin: "round",
    d: "M851.76 556.09l3.09 18.35 16.05-9.42.36.61-16.94 9.94-3.26-19.37.7-.11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    opacity: 0.2,
    d: "M1000.84 299.32l8.38 1.25-1.81-8.28.32-.06 1.91 8.73-8.85-1.32.05-.32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinejoin: "round",
    strokeWidth: 0.111,
    opacity: 0.289,
    d: "M1018.15 315.79l9.51 1.32-2.15-9.36.36-.08 2.26 9.88-10.03-1.4.05-.36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinejoin: "round",
    strokeWidth: 0.222,
    opacity: 0.378,
    d: "M1035.46 332.26l10.64 1.39-2.49-10.43.4-.1 2.62 11.01-11.22-1.47.05-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinejoin: "round",
    strokeWidth: 0.333,
    opacity: 0.467,
    d: "M1052.77 348.73l11.76 1.46-2.82-11.51.44-.11 2.98 12.15-12.41-1.55.05-.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinejoin: "round",
    strokeWidth: 0.444,
    opacity: 0.556,
    d: "M1070.08 365.19l12.89 1.54-3.15-12.59.47-.12 3.33 13.28-13.59-1.61.05-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinejoin: "round",
    strokeWidth: 0.556,
    opacity: 0.644,
    d: "M1087.39 381.66l14.02 1.6-3.49-13.66.51-.13 3.69 14.42-14.79-1.69.06-.54z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinejoin: "round",
    strokeWidth: 0.667,
    opacity: 0.733,
    d: "M1104.7 398.13l15.15 1.67-3.83-14.74.56-.15 4.04 15.56-15.98-1.76.06-.58z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinejoin: "round",
    strokeWidth: 0.778,
    opacity: 0.822,
    d: "M1122.02 414.6l16.26 1.74-4.16-15.82.6-.16 4.39 16.7-17.16-1.84.07-.62z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinejoin: "round",
    strokeWidth: 0.889,
    opacity: 0.911,
    d: "M1139.33 431.07l17.39 1.81-4.5-16.9.64-.17 4.75 17.83-18.35-1.91.07-.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinejoin: "round",
    d: "M1156.64 447.54l18.52 1.88-4.84-17.98.68-.18 5.11 18.97-19.54-1.99.07-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    opacity: 0.2,
    d: "M934.42 573.95l5.97-6.02-7.75-3.43.13-.29 8.17 3.62-6.29 6.35-.23-.23z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    opacity: 0.28,
    d: "M956.19 569.86l6.62-6.8-8.71-3.76.14-.33 9.19 3.97-6.98 7.18-.26-.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinejoin: "round",
    strokeWidth: 0.2,
    opacity: 0.36,
    d: "M977.96 565.77l7.27-7.58-9.68-4.09.16-.37 10.2 4.32-7.66 8-.29-.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinejoin: "round",
    strokeWidth: 0.3,
    opacity: 0.44,
    d: "M999.73 561.68l7.92-8.36-10.64-4.42.17-.4 11.22 4.66-8.35 8.83-.32-.31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinejoin: "round",
    strokeWidth: 0.4,
    opacity: 0.52,
    d: "M1021.5 557.59l8.57-9.14-11.6-4.75.18-.44 12.24 5.01-9.04 9.65-.35-.33z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinejoin: "round",
    strokeWidth: 0.5,
    opacity: 0.6,
    d: "M1043.27 553.5l9.22-9.92-12.56-5.08.2-.48 13.24 5.36-9.72 10.47-.38-.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinejoin: "round",
    strokeWidth: 0.6,
    opacity: 0.68,
    d: "M1065.04 549.41l9.87-10.7-13.52-5.41.21-.51 14.26 5.7-10.41 11.3-.41-.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinejoin: "round",
    strokeWidth: 0.7,
    opacity: 0.76,
    d: "M1086.82 545.32l10.51-11.48-14.48-5.74.22-.55 15.27 6.05-11.09 12.12-.43-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinejoin: "round",
    strokeWidth: 0.8,
    opacity: 0.84,
    d: "M1108.59 541.23l11.16-12.26-15.44-6.07.23-.58 16.29 6.4-11.78 12.94-.46-.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinejoin: "round",
    strokeWidth: 0.9,
    opacity: 0.92,
    d: "M1130.36 537.14l11.81-13.04-16.4-6.4.24-.62 17.3 6.75-12.46 13.76-.49-.45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinejoin: "round",
    d: "M1152.13 533.05l12.46-13.82-17.36-6.73.26-.66 18.31 7.1-13.15 14.59-.52-.48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.78 215h167.62a9.73 9.73 0 019.86 9.85v19.65a9.73 9.73 0 01-9.86 9.85H909.78a9.73 9.73 0 01-9.86-9.85v-19.7a9.73 9.73 0 019.86-9.8zm0-52.89h167.62a9.73 9.73 0 019.86 9.85v19.69a9.73 9.73 0 01-9.86 9.85H909.78a9.73 9.73 0 01-9.86-9.85V172a9.73 9.73 0 019.86-9.89zm0-53.38h167.62a9.73 9.73 0 019.86 9.85v19.69a9.73 9.73 0 01-9.86 9.85H909.78a9.73 9.73 0 01-9.86-9.85v-19.69a9.73 9.73 0 019.86-9.85z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#resiliency_svg__p)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M916.87 115.81h167.62a9.73 9.73 0 019.86 9.85v19.69a9.73 9.73 0 01-9.86 9.85H916.87a9.73 9.73 0 01-9.86-9.85v-19.69a9.73 9.73 0 019.86-9.85z",
    fill: "#6bc6c4",
    opacity: 0.47
  })), /*#__PURE__*/React.createElement("path", {
    d: "M909.78 108.73h167.62a9.73 9.73 0 019.86 9.85v19.69a9.73 9.73 0 01-9.86 9.85H909.78a9.73 9.73 0 01-9.86-9.85v-19.69a9.73 9.73 0 019.86-9.85z",
    fill: "none",
    stroke: "#0e1932",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.265
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 925.13,
    cy: 128.55,
    rx: 6.64,
    ry: 6.63,
    fill: "#253a60",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 951.69,
    cy: 128.55,
    rx: 6.64,
    ry: 6.63,
    fill: "#253a60",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 978.24,
    cy: 128.55,
    rx: 6.64,
    ry: 6.63,
    fill: "#253a60",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#resiliency_svg__q)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M916.87 169.19h167.62a9.73 9.73 0 019.86 9.85v19.69a9.73 9.73 0 01-9.86 9.85H916.87a9.73 9.73 0 01-9.86-9.85V179a9.73 9.73 0 019.86-9.81z",
    fill: "#6bc6c4",
    opacity: 0.47
  })), /*#__PURE__*/React.createElement("path", {
    d: "M909.78 162.11h167.62a9.73 9.73 0 019.86 9.85v19.69a9.73 9.73 0 01-9.86 9.85H909.78a9.73 9.73 0 01-9.86-9.85V172a9.73 9.73 0 019.86-9.89z",
    fill: "none",
    stroke: "#0e1932",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.265
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 925.13,
    cy: 181.78,
    rx: 6.64,
    ry: 6.63,
    fill: "#253a60",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 951.69,
    cy: 181.78,
    rx: 6.64,
    ry: 6.63,
    fill: "#253a60",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 978.24,
    cy: 181.78,
    rx: 6.64,
    ry: 6.63,
    fill: "#253a60",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#resiliency_svg__r)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M916.87 222h167.62a9.73 9.73 0 019.86 9.85v19.69a9.73 9.73 0 01-9.86 9.85H916.87a9.73 9.73 0 01-9.86-9.85v-19.66a9.73 9.73 0 019.86-9.88z",
    fill: "#6bc6c4",
    opacity: 0.47
  })), /*#__PURE__*/React.createElement("path", {
    d: "M909.78 215h167.62a9.73 9.73 0 019.86 9.85v19.65a9.73 9.73 0 01-9.86 9.85H909.78a9.73 9.73 0 01-9.86-9.85v-19.7a9.73 9.73 0 019.86-9.8z",
    fill: "none",
    stroke: "#0e1932",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.265
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 925.13,
    cy: 234.53,
    rx: 6.64,
    ry: 6.63,
    fill: "#253a60",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 951.69,
    cy: 234.53,
    rx: 6.64,
    ry: 6.63,
    fill: "#253a60",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 978.24,
    cy: 234.53,
    rx: 6.64,
    ry: 6.63,
    fill: "#253a60",
    opacity: 0.7
  })))));
}

export default __webpack_public_path__ + "static/resiliency.0b9ad2e6.svg";
export { SvgResiliency as ReactComponent };